import { useContext } from 'react';
import { Auth, AuthContext } from '@app/providers/auth-provider';

const useAuth = (): Auth => useContext(AuthContext);

export default useAuth;
